import { RecoverDataProposalOwnVehicle } from './model/recover-data-proposal/recover-data-proposal-own-vehicle';
import {
  PendenciaCaminhaoProprio,
  PendenciaCaminhaoProprioInfo,
  PendenciaCaminhaoProprioQuitado,
  PendenciaCaminhaoProprioImplemento,
} from './../ficha-timeline/ficha-modal-avalista/model/veiculo';
import { RecoverDataProposalProfessionalData } from './model/recover-data-proposal/recover-data-proposal-professional-data';
import { TelefoneCliente } from './model/telefone-cliente';
import { RecoverDataProposalCompanyProvidingService } from './model/recover-data-proposal/recover-data-proposal-company-providing-service';
import { RecoverDataProposalAddress } from './model/recover-data-proposal/recover-data-proposal-address';
import { FichaService } from './../ficha-veiculo.service';
import { RecoverDataProposal } from './model/recover-data-proposal/recover-data-proposal';

import { takeWhile, take, timeout, finalize, catchError } from 'rxjs/operators';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DadosProfissionais } from '../../shared/dados-profissionais/model/dados-profissionais';
import { LoginStorage } from './../../login/login.storage';
import { ModalMessageComponent } from './../../shared/modais/modal-message/modal-message.component';
import { FichaCadastro } from './ficha-cadastro';
import { FichaCadastroResultadoParcialComponent } from './ficha-cadastro-resultado-parcial/ficha-cadastro-resultado-parcial.component';
import { OperacoesGeralService } from './../../services/geral/operacoes/operacoes.geral.service';
import {
  getFichaContent,
  removeFichaContent,
  setFichaContent,
} from './helpers/salvarFicha';
import { Avalista } from './model/avalista';
import { Cliente } from './model/cliente';
import { TipoProdutoEnum } from '../../simulador-veiculo/enums/tipo-produto.enum';
import * as toastr from 'toastr';
import { RecoverDataProposalCustomerReference } from './model/recover-data-proposal/recover-data-proposal-customer-reference';
import { Referencia } from './model/referencia';
import { Telefone } from './model/telefone';
import { VeiculoSimulacao } from './ficha-cadastro-resultado-parcial/model/proposta/veiculo-simulacao';

@Component({
  selector: 'app-ficha-cadastro',
  templateUrl: './ficha-cadastro.component.html',
  styleUrls: ['./ficha-cadastro.component.css'],
})
export class FichaCadastroComponent implements OnInit, OnDestroy {
  fichaCadastro: FichaCadastro = new FichaCadastro();
  private isAlive = true;
  private content;
  private urlData = {};
  private recoverData: RecoverDataProposal;

  @ViewChild('resultadoParcial', { static: true })
  resultadoParcial: FichaCadastroResultadoParcialComponent;

  // @ViewChild('cadastroVeiculo', { static: true }) cadastroVeiculo: FichaCadastroVeiculoComponent;

  @ViewChild('modalMessage', { static: true })
  modalMessage: ModalMessageComponent;

  public amountGuarantor: number = 0;

  constructor(
    private route: ActivatedRoute,
    private loginStorage: LoginStorage,
    private operacoesGeralService: OperacoesGeralService,
    private fichaService: FichaService,
  ) {}

  ngOnInit() {
    this.initObservableParams();
    this.fichaCadastro.avalistaParentesco = 'none';
  }
  ngOnDestroy() {
    this.isAlive = false;
  }

  recuperarFichaComAnalise(item, id) {
    // if (item && item['proposta']['id'] !== id) {
    //   this.modalMessage.show(
    //     'Já existe um registro salvo para essa proposta, deseja carregar os dados?',
    //     'SIM',
    //     'NÃO'
    //   );
    //   this.content = item;
    // }
  }

  checkTypeFicha(params) {
    getFichaContent().then((item) => {
      if (item && Object.keys(item).length > 0) {
        if (item['passo'] > 5 && params.url === 'resultadoparcial') {
          this.recuperarFichaComAnalise(item, params.id);
        }
      }
    });
  }

  checkHasFicha(params) {
    this.checkTypeFicha(params);
  }

  getContext() {
    return window.location.pathname;
  }

  checkResponseModal(show) {
    if (show) {
      try {
        Object.keys(this.fichaCadastro).forEach((data) => {
          this.fichaCadastro[data] = this.content[data];
        });
      } catch (err) {
        throw new Error('ocorreu um erro para recuperar a ficha');
      } finally {
        if (this.getContext().substring(0, 17) === '/resultadoparcial') {
          this.fichaCadastro.getFichaLocalStorage = true;
        }
        this.insertDadosProfissionais();
        this.insertPrototype();
      }
    } else {
      removeFichaContent();
    }
  }

  private initObservableParams() {
    this.route.params
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((params) => {
        this.urlData = { ...params, url: this.route.snapshot.url[0].path };
        this.handleParamsAndUrl(this.urlData);
        this.checkHasFicha(this.urlData);
        this.getRecoverDataCustomer();
      });
  }

  private handleParamsAndUrl(params) {
    this.isAlive = false;
    switch (params.url) {
      case 'resultadoparcial':
        this.handleUrlResultadoParcial(params);
        break;
      case 'novaplaca':
        this.handleInformarNovaPlaca(params);
        break;
      case 'informargarantia':
        this.handleInformarGarantia(params);
        break;
      case 'nova-ficha-veiculo':
        this.handlerNovaFichaVeiculo(params);
        break;
      default:
        break;
    }
  }

  private handleUrlResultadoParcial(params: any) {
    this.fichaCadastro.setPasso(this.fichaCadastro.PASSO_RESULTADO_PARCIAL);
    const id: string = params['id'];
    this.resultadoParcial.setIsGettingFicha();
    this.resultadoParcial.simularProposta(id);
  }

  private handleInformarNovaPlaca(params: any) {
    const id: string = params['id'];
    this.fichaCadastro.passoCorrigirPLacaInvalida();
    // this.cadastroVeiculo.informarNovaPlaca(id);
  }

  private handleInformarGarantia(params: any) {
    const id: string = params['id'];
    this.fichaCadastro.placaVeiculo = '';
    this.fichaCadastro.hasZeroKm = false;
    this.fichaCadastro.hasUtilizacaoAgropecuaria = false;
    this.fichaCadastro.passoCorrigirFipeNotFound();
    // this.cadastroVeiculo.informarGarantia(id);
  }

  private handlerNovaFichaVeiculo(params: any) {
    this.fichaCadastro.produtoTipo = (params.produto || '').toUpperCase();
    this.fichaCadastro.solicitanteTipo = (
      params.solicitante || ''
    ).toUpperCase();
    this.fichaCadastro.veiculoTipo = (params.tipoVeiculo || '').toUpperCase();

    let idLojista = this.fichaCadastro.IDLojista;
    if (
      params.solicitante === 'TIPO_SOLIC_CLIENTE' ||
      params.solicitante === 'TIPO_SOLIC_OUTRA'
    ) {
      idLojista = this.loginStorage.agente.lojaBalcaoId;
    }

    this.fichaCadastro.setPayload(
      'grupo1',
      params.produto === 'financiamento'
        ? TipoProdutoEnum.FINANCIMENTO
        : TipoProdutoEnum.REFINANCIAMENTO
    );
    this.fichaCadastro.setPayload('lojaId', idLojista);
    this.getRendaPorProduto();
  }

  getRendaPorProduto() {
    this.operacoesGeralService
      .produtosPorUsuario(this.fichaCadastro.payload.grupo1)
      .pipe(
        timeout(20000),
        take(1),
        finalize(() => setFichaContent(this.fichaCadastro))
      )
      .subscribe((res) => {
        [this.fichaCadastro.limiteRenda] = this.limiteRenda(res);
      });
  }

  getRendaPorGrupo() {
    this.operacoesGeralService
      .produtosPorUsuario(this.fichaCadastro.grupo1)
      .pipe(
        timeout(20000),
        take(1),
        finalize(() => setFichaContent(this.fichaCadastro))
      )
      .subscribe((res) => {
        [this.fichaCadastro.limiteRenda] = this.limiteRenda(res);
      });
  }

  limiteRenda(res) {
    return res.filter((item) => {
      return (
        item.descricao
          .toUpperCase()
          .normalize('NFD')
          .replace(/[^a-zA-Zs]/g, '') === this.fichaCadastro.veiculoTipo
      );
    });
  }

  // Após recuperar a ficha, faz se necessário inserir todos os métodos das classes atribuidas dentro
  // de ficha cadastro
  insertPrototype() {
    Object.setPrototypeOf(
      this.fichaCadastro,
      Object.getPrototypeOf(new FichaCadastro())
    );
    Object.setPrototypeOf(
      this.fichaCadastro._client,
      Object.getPrototypeOf(new Cliente())
    );
    Object.setPrototypeOf(
      this.fichaCadastro._client,
      Object.getPrototypeOf(new FichaCadastro()._client)
    );
    Object.setPrototypeOf(
      this.fichaCadastro._avalista,
      Object.getPrototypeOf(new Avalista())
    );
    Object.setPrototypeOf(
      this.fichaCadastro._avalista,
      Object.getPrototypeOf(new FichaCadastro()._avalista)
    );
    Object.setPrototypeOf(
      this.fichaCadastro._avalistas,
      Object.getPrototypeOf([new Avalista()])
    );
    Object.setPrototypeOf(
      this.fichaCadastro._avalistas,
      Object.getPrototypeOf(new FichaCadastro()._avalistas)
    );
    Object.setPrototypeOf(
      this.fichaCadastro.avalistas,
      Object.getPrototypeOf([new Avalista(), new Avalista(), new Avalista()])
    );
  }

  public insertDadosProfissionais() {
    if (this.fichaCadastro._client.dadoProfissional.classeProfissional) {
      this.fichaCadastro._client.dadoProfissional = DadosProfissionais.of(
        this.fichaCadastro._client.dadoProfissional.classeProfissional.id,
        this.fichaCadastro._client.dadoProfissional.profissao.id,
        this.fichaCadastro._client.dadoProfissional.empresa.nome,
        this.fichaCadastro._client.dadoProfissional.empresa.telefone,
        this.fichaCadastro._client.dadoProfissional.empresa.endereco,
        this.fichaCadastro._client.dadoProfissional.tempoExperiencia
          .valorNumerico,
        this.fichaCadastro._client.dadoProfissional.familiaresRamo
      );
    }
    if (this.fichaCadastro._avalista.dadoProfissional.classeProfissional) {
      this.fichaCadastro._avalista.dadoProfissional = DadosProfissionais.of(
        this.fichaCadastro._avalista.dadoProfissional.classeProfissional.id,
        this.fichaCadastro._avalista.dadoProfissional.profissao.id,
        this.fichaCadastro._avalista.dadoProfissional.empresa.nome,
        this.fichaCadastro._avalista.dadoProfissional.empresa.telefone,
        this.fichaCadastro._avalista.dadoProfissional.empresa.endereco
      );
    }
  }

  private getRecoverDataCustomer() {
    if (this.urlData && !this.urlData['id']) {
      return;
    }
    this.fichaService
      .getRecoverFullDataProposal(this.urlData['id'])
      .pipe(
        take(1),
        catchError((error) => {
          throw error;
        })
      )
      .subscribe((res: RecoverDataProposal) => {
        this.recoverData = res;
        if (this.recoverData && this.recoverData.proposal) {
          this.insertPrototype();
          this.amountGuarantor = this.recoverData.proposal.guarantors.length;
          this.assignFichaCadastroClient();
          if (this.recoverData.proposal.customer) {
            this.fichaCadastro.setDadosCliente = true;
            this.fichaCadastro.shoudInitializeCustomer = false;
          }
          if (this.recoverData.proposal.guarantors.length > 0) {
            this.fichaCadastro.setAvalista(true);
            this.fichaCadastro.avalistas = [];
            this.fichaCadastro.setDadosAvalistas = [];
            this.recoverData.proposal.guarantors.forEach((_) => {
              this.fichaCadastro.avalistas.push(new Avalista());
              this.fichaCadastro.setDadosAvalistas.push(true);
            });
          }
          this.fichaCadastro.recoverData = res;
        }
      });
  }

  assignFichaCadastroClient() {
    this.fichaCadastro.proposta.id = this.recoverData.proposal.id;
    this.fichaCadastro._client.id = this.recoverData.proposal.customer.id;
    this.getRecoverDataProposalAddressCustomer(
      this.recoverData.proposal.customer.addresses
    );
    this.getCompanyProvidingService(
      this.recoverData.proposal.customer.companyProvidingService
    );
    this.fichaCadastro._client.cpf = this.recoverData.proposal.customer.cpf;
    this.fichaCadastro._client.clientePpe =
      this.recoverData.proposal.customer.customerPpe;
    this.fichaCadastro._client.clienteReferencias = this.getCustomerReferences(
      this.recoverData.proposal.customer.customerReferences
    );
    this.fichaCadastro._client.dataNascimento =
      this.recoverData.proposal.customer.dateOfBirth &&
      this.recoverData.proposal.customer.dateOfBirth > 0
        ? this.recoverData.proposal.customer.dateOfBirth
        : null;
    this.fichaCadastro._client.idTipoDocumento =
      this.recoverData.proposal.customer.documentTypeId;
    this.fichaCadastro._client.email = this.recoverData.proposal.customer.email;
    this.fichaCadastro._client.valorPatrimonio = Number(
      this.recoverData.proposal.customer.equityValue
    );
    this.fichaCadastro._client.nomePai =
      this.recoverData.proposal.customer.fatherName;
    this.fichaCadastro._client.idEstadoCivil =
      this.recoverData.proposal.customer.idCivilStatus;
    this.fichaCadastro._client.renda =
      this.recoverData.proposal.customer.income;
    this.fichaCadastro._client.tipoEnderecoCorrespondencia =
      this.recoverData.proposal.customer.mailingAddressType;
    this.fichaCadastro._client.nomeMae =
      this.recoverData.proposal.customer.motherName;
    this.fichaCadastro._client.nome = this.recoverData.proposal.customer.name;
    this.fichaCadastro._client.idNacionalidade =
      this.recoverData.proposal.customer.nationalityId;
    this.fichaCadastro._client.naturalDe =
      this.recoverData.proposal.customer.naturalness;
    this.fichaCadastro._client.naturalDeUf =
      this.recoverData.proposal.customer.naturalnessFederalUnit;

    this.fichaCadastro._client.rgIe = this.recoverData.proposal.customer.rgIe;

    this.fichaCadastro._client.rgIeData =
      this.recoverData.proposal.customer.rgIeDt &&
      this.recoverData.proposal.customer.rgIeDt > 0
        ? this.recoverData.proposal.customer.rgIeDt
        : null;

    this.fichaCadastro._client.rgIeEmissor =
      this.recoverData.proposal.customer.rgIeIssuer;

    this.fichaCadastro._client.tipoTransporte =
      this.recoverData.proposal.customer.transportType;

    this.fichaCadastro._client.condutorCaminhao =
      this.recoverData.proposal.customer.truckDriver;

    this.fichaCadastro.veiculoProprioCaminhao = this.getOwnVechicles(
      this.recoverData.proposal.customer.ownVehicles
    );

    this.fichaCadastro._client.dadoProfissional = this.parseProfessionalData(
      this.fichaCadastro.recoverData.proposal.customer.professionalData
    );

    this.fichaCadastro._client.telefones = this.getRecoverDataCustomerPhones(
      this.recoverData.proposal.customer.phones
    );

    this.fichaCadastro._client.tipoTransporteOutro =
      this.recoverData.proposal.customer.othersTransportTypeDescription;

    this.fichaCadastro.proposta.cliente = this.fichaCadastro._client;
  }

  getOwnVechicles(
    data: RecoverDataProposalOwnVehicle[]
  ): PendenciaCaminhaoProprio[] {
    const retorno: PendenciaCaminhaoProprio[] = [];
    data.forEach((element) => {
      const info: PendenciaCaminhaoProprioInfo = {
        veiculoPlaca: element.plate,
        veiculoAno: `${element.modelYear}`,
        veiculoMarca: {
          id: `${element.brand.id}`,
          descricao: element.brand.description,
        },
        veiculoModelo: {
          id: `${element.model.id}`,
          descricao: element.brand.description,
        },
        veiculoVersao: {
          id: `${element.version.id}`,
          descricao: element.version.description,
        },
        tempoCaminhao: element.OwnsTime,
      };
      const quitado: PendenciaCaminhaoProprioQuitado = {
        veiculoQuitado: element.paid === 'S' ? true : false,
        totalParcela: element.amountParcels,
        valorParcela: element.valueParcels,
        parcelasQuitada: element.amountPaidParcels,
      };
      const implemento: PendenciaCaminhaoProprioImplemento = {
        veiculoImplemento: element.hasImplement === 'S' ? true : false,
        veiculoAno: `${element.modelYear}`,
        veiculoMarca: {
          id: `${element.brand.id}`,
          descricao: element.brand.description,
        },
        veiculoModelo: {
          id: `${element.model.id}`,
          descricao: element.model.description,
        },
      };
      retorno.push({ info, quitado, implemento });
    });

    return retorno;
  }

  parseProfessionalData(
    data: RecoverDataProposalProfessionalData
  ): DadosProfissionais {
    if (data) {
      const dadosProfissionais = new DadosProfissionais();
      dadosProfissionais.classeProfissional = {
        id: data.professionalClassId,
        descricao: '',
        empresa: data.companyName ? true : false,
      };
      dadosProfissionais.profissao = {
        idGrupoProfissao: data.professionGroupId,
        id: data.ProfessionId,
        descricao: '',
      };
      dadosProfissionais.empresa = {
        nome: data.companyName,
        telefone: data.phone ? data.phone.ddd + data.phone.number : undefined,
        endereco: {
          idTipoEndereco: data.address ? data.address.addressTypeId : undefined,
          uf: data.address ? data.address.federalUnit : undefined,
          cidade: data.address ? data.address.city : undefined,
          endereco: data.address ? data.address.address : undefined,
          bairro: data.address ? data.address.neighborhood : undefined,
          numero: data.address ? data.address.number : undefined,
          complemento: data.address ? data.address.complement : undefined,
          cep: data.address ? data.address.zip : undefined,
          condicaoResidencia: String(
            data.address ? data.address.residenceCondition : ''
          ),
          tempoResidencia: String(
            data.address ? data.address.residenceTime : ''
          ),
          $cep: data.address ? data.address.zip : undefined,
          $idTipoEndereco: 1,
          condicaoResidenciaOutro: undefined,
        },
        valid: true,
      };
      dadosProfissionais.tempoExperiencia = {
        descricao: '',
        valorNumerico: data.experienceIndustryTime,
      };
      dadosProfissionais.familiaresRamo = data.familyInBusiness;
      return dadosProfissionais;
    }
    return null;
  }

  private getRecoverDataProposalAddressCustomer(
    address: RecoverDataProposalAddress[]
  ) {
    if (address && address.length > 0) {
      address.forEach((ref: RecoverDataProposalAddress) => {
        if (ref.correspondence) {
          this.fichaCadastro._client.enderecoCorrespondencia.endereco =
            ref.address;
          this.fichaCadastro._client.enderecoCorrespondencia.idTipoEndereco =
            ref.addressTypeId;
          this.fichaCadastro._client.enderecoCorrespondencia.cidade = ref.city;
          this.fichaCadastro._client.enderecoCorrespondencia.complemento =
            ref.complement;
          this.fichaCadastro._client.enderecoCorrespondencia.uf =
            ref.federalUnit;
          this.fichaCadastro._client.enderecoCorrespondencia.bairro =
            ref.neighborhood;
          this.fichaCadastro._client.enderecoCorrespondencia.numero =
            ref.number;
          this.fichaCadastro._client.enderecoCorrespondencia.condicaoResidencia =
            String(ref.residenceCondition);
          this.fichaCadastro._client.enderecoCorrespondencia.tempoResidencia =
            String(ref.residenceTime);
          this.fichaCadastro._client.enderecoCorrespondencia.cep =
            ref.singleZipCode;
        } else {
          (this.fichaCadastro._client.enderecos.endereco = ref.address),
            (this.fichaCadastro._client.enderecos.idTipoEndereco =
              ref.addressTypeId);
          this.fichaCadastro._client.enderecos.cidade = ref.city;
          this.fichaCadastro._client.enderecos.complemento = ref.complement;
          this.fichaCadastro._client.enderecos.uf = ref.federalUnit;
          this.fichaCadastro._client.enderecos.bairro = ref.neighborhood;
          this.fichaCadastro._client.enderecos.numero = ref.number;
          this.fichaCadastro._client.enderecos.condicaoResidencia = String(
            ref.residenceCondition
          );
          this.fichaCadastro._client.enderecos.tempoResidencia = String(
            ref.residenceTime
          );
          this.fichaCadastro._client.enderecos.cep = ref.singleZipCode;
        }
      });
    }
  }

  private getCompanyProvidingService(
    prestadora: RecoverDataProposalCompanyProvidingService
  ) {
    if (prestadora) {
      this.fichaCadastro._client.empresaPrestacaoServico.ddd = prestadora.ddd;
      this.fichaCadastro._client.empresaPrestacaoServico.nome = prestadora.name;
      this.fichaCadastro._client.empresaPrestacaoServico.telefone =
        prestadora.phone;
      this.fichaCadastro._client.empresaPrestacaoServico.tipoTransporte =
        prestadora.transportType;
      this.fichaCadastro._client.empresaPrestacaoServico.tipoTransporteOutro =
        prestadora.othersTransportTypeDescription;
    }
  }

  private getCustomerReferences(
    reference: RecoverDataProposalCustomerReference[]
  ): Referencia[] {
    const data: Referencia[] = [];
    if (reference && reference.length > 0) {
      reference.forEach((ref: RecoverDataProposalCustomerReference) => {
        if (ref.phones[0]) {
          const telefone = new Telefone(
            ref.phones[0].ddd,
            ref.phones[0].number,
            ref.phones[0].categoryId,
            ref.phones[0].categoryPhoneId
          );
          data.push(
            new Referencia(ref.name, ref.relationshipDegreeId, telefone, '')
          );
        } else {
          data.push(new Referencia(ref.name, ref.relationshipDegreeId));
        }
      });
    }
    return data;
  }

  private getRecoverDataCustomerPhones(phones: any[]): TelefoneCliente {
    let data: TelefoneCliente = undefined;
    if (phones && phones.length > 0) {
      data = new TelefoneCliente(
        phones.map((phone) => ({
          categoria: { id: Number(phone.categoryId) },
          ddd: phone.ddd,
          telefone: phone.number,
        }))
      );
    }
    return data;
  }

  private getRecoverDataProposalProfessionalData(
    dadosProfissonal: any
  ): RecoverDataProposalProfessionalData {
    const data: RecoverDataProposalProfessionalData =
      {} as RecoverDataProposalProfessionalData;
    if (dadosProfissonal && dadosProfissonal.idProfissao) {
      data.ProfessionId = dadosProfissonal.idProfissao;
      data.companyName = dadosProfissonal.nomeEmpresa;
      data.experienceIndustryTime =
        dadosProfissonal.tempoExperiencia.valorNumerico;
      data.familyInBusiness = dadosProfissonal.familiaresRamo;
      data.phone = dadosProfissonal.telefoneEmpresa;
      data.professionGroupId = dadosProfissonal.idGrupoProfissao;
      data.professionalClassId = dadosProfissonal.classeProfissional.id;
    }
    return data;
  }
}
